import { console_log } from '../../config';
import { PrismaPolicies, PrispekPolicies, SpektraPolicies } from '../../constants';

export interface ReadMoreProps {
    Guid: string;
    description?: string;
    list?: Array<{ title?: string; item?: string; Guid: number | string }>;
}

export interface blogProps {
    Guid?: string;
    Title: string;
    DatePosted: string | Date;
    Description: string;
    ReadMore?: 'Array<ReadMoreProps>' | string;
    Link: string;
    LinkTip?: string;
    CoverImage?: string;
    Gallery?: '{ Gallery: Array<string> }';
}

export type blogsType = Array<blogProps>;
interface basePolicyProps {
    Guid?: string;
    Reference?: string;
    Name: string;
    Variant: 'item' | 'folder';
}
export interface policyProps extends basePolicyProps {
    Policies?: Array<basePolicyProps>;
}
export type policiesType = Array<policyProps>;
export interface infoProps {
    blogs: blogsType;
    policies: policiesType;
}

export type infoActionTypes =
    | { type: 'RESET' }
    | { type: 'SET_BLOGS'; blogs: blogsType }
    | { type: 'ADD_BLOG'; blog: blogProps }
    | {
          type: 'RESET_POLICIES';
          company: 0 | 1 | 2;
      }
    | {
          type: 'SET_POLICIES';
          policies: policiesType;
          readPolicies: policiesType;
          //   company: 0 | 1 | 2;
      };

export const infoInitialState: infoProps = {
    blogs: [],
    policies: []
};

export const infoReducer = (state: infoProps, action: infoActionTypes) => {
    console_log(action.type, '\n', action);
    console_log('====================================');
    let POLICIES: policiesType = PrispekPolicies;
    switch (action.type) {
        case 'RESET':
            return infoInitialState;
        case 'SET_BLOGS':
            return { ...state, blogs: action.blogs };
        case 'ADD_BLOG':
            return { ...state, blogs: [...state.blogs, action.blog] };
        case 'RESET_POLICIES':
            POLICIES =
                action.company === 1
                    ? PrispekPolicies
                    : action.company === 0
                    ? PrismaPolicies
                    : SpektraPolicies;
            return {
                ...state,
                policies: POLICIES
            };

        case 'SET_POLICIES':
            POLICIES = action.policies.map(policy =>
                policy.Variant === 'folder'
                    ? {
                          ...policy,
                          Policies: policy.Policies?.map(subPolicy =>
                              subPolicy.Guid !== undefined
                                  ? { ...subPolicy, Guid: undefined }
                                  : subPolicy
                          )
                      }
                    : policy.Guid !== undefined
                    ? { ...policy, Guid: undefined }
                    : policy
            );
            action.readPolicies.forEach(readPolicy =>
                POLICIES.forEach((policy, index) =>
                    policy.Variant === 'folder'
                        ? policy.Policies?.forEach(
                              (subPolicy, subIndex) =>
                                  readPolicy.Reference === subPolicy.Reference &&
                                  policy.Policies &&
                                  (policy.Policies[subIndex] = readPolicy)
                          )
                        : readPolicy.Name === policy.Name &&
                          (POLICIES[index] = readPolicy)
                )
            );

            return {
                ...state,
                policies: POLICIES
            };
        default:
            return state;
    }
};
